<template>
  <div class="card p-4 shadow-sm">
    <!-- Toast -->
    <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
      <div class="toast show align-items-center text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body"><i :class="iconoToast" class="me-2"></i>{{ alerta.mensaje }}</div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>

    <!-- Total -->
    <div class="mb-3">
      <h5>Total Inventario Cocina: Q.{{ totalInventario.toFixed(2) }}</h5>
    </div>

    <!-- Filtros -->
    <div class="row mb-3 g-2">
      <div class="col-md-5">
        <input type="text" class="form-control" placeholder="Buscar producto por nombre" v-model="busqueda" />
      </div>
      <div class="col-md-4">
        <select class="form-select" v-model="filtroTipo" @change="aplicarFiltros">
          <option value="">Filtrar por tipo...</option>
          <option v-for="tipo in catalogoTipos" :key="tipo.IdTipoProducto" :value="tipo.IdTipoProducto">
            {{ tipo.NombreTipo }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <button class="btn btn-secondary w-100" @click="limpiarFiltros">Limpiar filtros</button>
      </div>
    </div>
    <div class="row mb-3 g-2">
      <div class="col-md-5">
        <select class="form-select" v-model="ordenarPor">
          <option value="">Ordenar por...</option>
          <option value="nombre-asc">Nombre (A-Z)</option>
          <option value="nombre-desc">Nombre (Z-A)</option>
          <option value="tipo-asc">Tipo (A-Z)</option>
          <option value="tipo-desc">Tipo (Z-A)</option>
        </select>
      </div>
    </div>

    <!-- Botón PDF -->
    <div class="mb-3 d-flex justify-content-start">
      <button class="btn btn-danger" @click="descargarPDF">
        <i class="bx bxs-file-pdf"></i> Generar Reporte PDF
      </button>
    </div>

    <!-- Tabla -->
    <div class="table-responsive">
      <table class="table table-bordered text-center align-middle">
        <thead class="table-light">
          <tr>
            <th>Nombre</th>
            <th>Tipo</th>
            <th>Stock Actual</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="productosFiltrados.length === 0">
            <td colspan="4">No hay productos registrados.</td>
          </tr>
          <tr v-for="prod in productosFiltrados" :key="prod.IdInventarioCocina">
            <td>{{ prod.NombreProducto }}</td>
            <td>
              <span v-if="prod.NombreTipo" class="badge bg-secondary">{{ prod.NombreTipo }}</span>
              <span v-else>-</span>
            </td>
            <td>{{ prod.StockActual }}</td>
            <td>
              <button class="btn btn-primary btn-sm me-2" @click="abrirModal(prod)">Editar</button>
              <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(prod)">Eliminar</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal Editar -->
    <div v-if="mostrarModal" class="modal-backdrop" @click.self="cerrarModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h5 class="modal-title">Editar Stock — {{ productoEditar?.NombreProducto }}</h5>
          <button type="button" class="btn-close" @click="cerrarModal"></button>
        </div>
        <div class="modal-body">
          <label class="form-label">Stock Actual</label>
          <input v-model.number="productoEditar.StockActual" type="number" min="0" class="form-control" />
        </div>
        <div class="modal-footer mt-3">
          <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
          <button class="btn btn-primary" @click="actualizarProducto">Actualizar</button>
        </div>
      </div>
    </div>

    <!-- Modal Eliminar -->
    <div v-if="mostrarModalEliminar" class="modal-backdrop" @click.self="cerrarModalEliminar">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
          <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
        </div>
        <div class="modal-body">
          <p>¿Eliminar <strong>{{ productoEliminar?.NombreProducto }}</strong> del inventario de cocina?</p>
        </div>
        <div class="modal-footer mt-3">
          <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
          <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "InventarioCocina",
  data() {
    return {
      productos: [],
      catalogoTipos: [],
      busqueda: "",
      filtroTipo: "",
      ordenarPor: "",
      mostrarModal: false,
      mostrarModalEliminar: false,
      productoEditar: null,
      productoEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" }
    };
  },
  computed: {
    productosFiltrados() {
      let lista = this.productos;
      const q = this.busqueda.trim().toLowerCase();
      if (q) {
        lista = lista.filter(p => (p.NombreProducto || "").toLowerCase().includes(q));
      }
      if (this.filtroTipo) {
        lista = lista.filter(p => p.IdTipoProducto == this.filtroTipo);
      }
      if (this.ordenarPor) {
        const [campo, dir] = this.ordenarPor.split('-');
        const factor = dir === 'desc' ? -1 : 1;
        lista = lista.slice().sort((a, b) => {
          const va = campo === 'tipo' ? (a.NombreTipo || '') : (a.NombreProducto || '');
          const vb = campo === 'tipo' ? (b.NombreTipo || '') : (b.NombreProducto || '');
          return factor * va.localeCompare(vb);
        });
      }
      return lista;
    },
    totalInventario() {
      return this.productos.reduce((total, p) => {
        return total + (Number(p.StockActual) || 0) * (Number(p.PrecioCosto) || 0);
      }, 0);
    },
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    }
  },
  methods: {
    cerrarToast() { this.mostrarToast = false; },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerProductos() {
      const { data } = await axios.get(`${API_URL}/inventario-cocina`);
      this.productos = (data || []).map(item => ({
        IdInventarioCocina: item.IdInventarioCocina,
        NombreProducto: item.producto?.NombreProducto ?? "",
        StockActual: Number(item.StockActual) || 0,
        PrecioCosto: Number(item.producto?.PrecioCosto) || 0,
        IdTipoProducto: item.producto?.IdTipoProducto ?? null,
        NombreTipo: item.producto?.tipo_producto?.NombreTipo ?? null
      }));
    },
    async obtenerCatalogoTipos() {
      const { data } = await axios.get(`${API_URL}/tipos-producto-restaurante`);
      this.catalogoTipos = data;
    },
    aplicarFiltros() { /* reactivo via computed */ },
    limpiarFiltros() {
      this.busqueda = "";
      this.filtroTipo = "";
      this.ordenarPor = "";
    },
    abrirModal(prod) {
      this.productoEditar = { ...prod };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.productoEditar = null;
      this.mostrarModal = false;
    },
    async actualizarProducto() {
      if (this.productoEditar.StockActual < 0) {
        this.mostrarAlerta("El stock no puede ser negativo", "danger");
        return;
      }
      try {
        await axios.put(`${API_URL}/inventario-cocina/${this.productoEditar.IdInventarioCocina}`, {
          StockActual: this.productoEditar.StockActual
        });
        this.mostrarAlerta("Stock actualizado correctamente", "success");
        this.cerrarModal();
        this.obtenerProductos();
      } catch {
        this.mostrarAlerta("Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(prod) {
      this.productoEliminar = { ...prod };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.productoEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async confirmarEliminar() {
      try {
        await axios.delete(`${API_URL}/inventario-cocina/${this.productoEliminar.IdInventarioCocina}`);
        this.mostrarAlerta("Producto eliminado correctamente", "success");
        this.obtenerProductos();
      } catch {
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    descargarPDF() {
      const params = {};
      if (this.busqueda.trim()) params.nombre = this.busqueda.trim();
      if (this.filtroTipo) params.id_tipo = this.filtroTipo;
      if (this.ordenarPor) {
        const [campo, dir] = this.ordenarPor.split('-');
        params.ordenar_por = campo;
        params.direccion = dir;
      }
      axios.get(`${API_URL}/reporte-inventario-cocina`, { responseType: 'blob', params })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'reporte_inventario_cocina.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }).catch(error => console.error('Error descargando PDF:', error));
    }
  },
  mounted() {
    this.obtenerProductos();
    this.obtenerCatalogoTipos();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 480px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,.3);
}
</style>
